export const getRootStyles = ({ unread }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'stretch',
  gap: '12px',
  padding: '10px 12px 10px 16px',
  borderBottom: ({ palette }) => `1px solid ${palette.border.light}`,
  backgroundColor: unread ? ({ palette }) => palette.background.paper : 'transparent',
  cursor: 'pointer',
  transition: 'background-color 120ms ease',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.background.secondary,
  },
});

export const getAccentStripeStyles = ({ unread }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  width: '3px',
  backgroundColor: unread ? ({ palette }) => palette.primary.main : 'transparent',
});

export const avatarColumnStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  flexShrink: 0,
  paddingTop: '2px',
};

export const bodyColumnStyles = {
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '2px',
};

export const headerRowStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
  minWidth: 0,
};

export const channelNameStyles = {
  color: ({ palette }) => palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  minWidth: 0,
  flex: 1,
};

export const metaRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  flexShrink: 0,
};

export const loanChipStyles = {
  color: ({ palette }) => palette.primary.main,
  backgroundColor: ({ palette }) => palette.background.paper,
  border: ({ palette }) => `1px solid ${palette.primary.light}`,
  borderRadius: '10px',
  padding: '0 8px',
  lineHeight: '18px',
  height: '18px',
  whiteSpace: 'nowrap',
};

export const timestampStyles = {
  color: ({ palette }) => palette.text.secondary,
  whiteSpace: 'nowrap',
};

export const previewRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
};

export const senderStyles = {
  color: ({ palette }) => palette.primary.main,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const getPreviewTextStyles = ({ unread }) => ({
  color: ({ palette }) => (unread ? palette.text.primary : palette.text.secondary),
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  whiteSpace: 'normal',
});

export const typingLabelStyles = {
  color: ({ palette }) => palette.primary.main,
  fontStyle: 'italic',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const trailingColumnStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  justifyContent: 'flex-start',
  gap: '6px',
  flexShrink: 0,
};

export const badgeStyles = {
  minWidth: '18px',
  height: '18px',
  padding: '0 6px',
  borderRadius: '9px',
  backgroundColor: ({ palette }) => palette.primary.main,
  color: ({ palette }) => palette.primary.contrastText,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  lineHeight: 1,
};

export const actionSlotStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
};
